import classNames from "classnames";
import React from "react";

import { PolymorphicComponentProps } from "lib/@types/utils/polymorphic.types";

export type ModalHeaderComponentProps = {
    toggle?: React.MouseEventHandler<any>;
    closeAriaLabel?: string;
    charCode?: string | number;
    close?: React.ReactNode;
};

export type ModalHeaderProps<T extends React.ElementType> =
    PolymorphicComponentProps<
        T,
        ModalHeaderComponentProps,
        "div" | "h2" | "h5"
    >;

const ModalHeader = <T extends React.ElementType = "h5">({
    className,
    children,
    toggle,
    tag,
    closeAriaLabel = "Close",
    charCode = 215,
    close,
    ...attributes
}: ModalHeaderProps<T>) => {
    const Tag = tag || ("h5" as React.ElementType);
    let closeButton;
    const classes = classNames(className, "modal-header");

    if (!close && toggle) {
        const closeIcon =
            typeof charCode === "number"
                ? String.fromCharCode(charCode)
                : charCode;
        closeButton = (
            <button
                type="button"
                onClick={toggle}
                className={"close"}
                aria-label={closeAriaLabel}
            >
                <span aria-hidden="true">{closeIcon}</span>
            </button>
        );
    }

    return (
        <div {...attributes} className={classes}>
            <Tag className={"modal-title"}>{children}</Tag>
            {close || closeButton}
        </div>
    );
};

export { ModalHeader };
